import { CircularProgress } from '@material-ui/core';
import vehiclesEndpoint from 'app/api/services/vehiclesEndpoint';
import notification from 'app/config/notification';
import { SERVICES_CODES, SERVICES_PROPERTIES } from 'app/config/services';
import { setVehiclePlateByCompany } from 'app/store/slices/vehicle';
import { FormServiceContext } from 'app/utils/contexts';
import { setupVehicleInitialValues, setupVehiclePayload } from 'app/utils/forms/services/vehicles';
import { validateVehicleRequest } from 'app/utils/forms/validators/vehicle';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { injectIntl } from 'react-intl';

import { useDispatch, useSelector } from 'react-redux';

const Vehicles = props => {
  const dispatch = useDispatch();

  const {
    intl,
    classes,
    loading,
    loadingDocuments,
    setLoadingDocuments,
    onCancel,
    onSave,
    onSubmit,
    initialValues,
    setInitialValues,
  } = props;

  const internalNewRequest = useSelector(state => state.forms.internalNewRequest);
  const request = useSelector(state => state.requests.details);
  const vehicles = useSelector(state => state.forms.vehicles);
  const authUser = useSelector(state => state.auth.user);
  const documentsStore = useSelector(state => state.services.documents);

  const [canEdit, setCanEdit] = useState(true);
  const [errorsList, setErrorsList] = useState({});

  useEffect(() => {
    const init = () => {
      if (Object.keys(internalNewRequest).length > 0) {
        const temp = setupVehicleInitialValues(internalNewRequest);
        setInitialValues(temp);
      }
    };
    init();
  }, [internalNewRequest, setInitialValues]);

  const validationSchema = useMemo(() => {
    return SERVICES_PROPERTIES[internalNewRequest.cdServico]
      ? SERVICES_PROPERTIES[internalNewRequest.cdServico].validationSchema
      : {};
  }, [internalNewRequest.cdServico]);

  const isAddVehicle = useMemo(() => {
    return (
      internalNewRequest.cdServico === SERVICES_CODES.INCLUSAO_VEICULOS ||
      internalNewRequest.cdServico === SERVICES_CODES.INCLUSAO_VEICULOS_SEM_CRC
    );
  }, [internalNewRequest.cdServico]);

  useEffect(() => {
    const init = async () => {
      // const deCpfCnpj = internalNewRequest.company?.deCnpjMatriz ||
      //                   internalNewRequest.company?.deCpf ||
      //                   internalNewRequest.company?.deCpfCnpj ||
      //                   internalNewRequest.user.deCpfCnpj;

      // const response = await vehiclesEndpoint.getInspectedVehiclesByDocument(deCpfCnpj);

      if (internalNewRequest && internalNewRequest.company) {

        const response = await vehiclesEndpoint.getVehiclesPlatesByCompany(
          internalNewRequest.company.cdEmpresa,
        );

        if (!isAddVehicle) {
          if (!response?.data || response?.data.length <= 0) {
            if (!request.situacao) {
              notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.NO_VEHICLES_FOUND' }), {
                toastId: 'MESSAGES.SERVICE.FORMS.NO_VEHICLES_FOUND',
                type: 'error',
              });

              setCanEdit(false);
            }
          } else {
            dispatch(setVehiclePlateByCompany(response.data));
          }
        }
        // dispatch(fetchVehicleAllPlates());
      }
    };
    init();
  }, [dispatch, internalNewRequest, intl, isAddVehicle, request.situacao]);

  useEffect(() => {
    if (internalNewRequest.cdServico === SERVICES_CODES.EXCLUSAO_VEICULOS) {
      setCanEdit(false);
    } else {
      setCanEdit(true);
    }
  }, [internalNewRequest.cdServico]);

  const setupPayload = useCallback(
    (valuesCopy, requestJsonData) => {
      const payload = setupVehiclePayload({ values: valuesCopy, requestJsonData, vehicles });
      if (!validateVehicleRequest({ values: payload, intl })) {
          return;
      }
      return payload;
    },
    [intl, vehicles],
  );

  const handleSave = useCallback(
    (values, fromSubmit, oldData) => {
      onSave(values, fromSubmit, oldData, setupPayload);
    },
    [onSave, setupPayload],
  );

  const handleSubmit = useCallback(
    (values) => {
      if ((documentsStore.length > 0 && values.documentos?.length === 0) || vehicles.length === 0) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_MANDATORY_INFOS' }), {
          toastId: 'MISSING_MANDATORY_INFOS',
          type: 'warning',
        });
        return false;
      }

      onSubmit(values, onSave, setupPayload);
    },
    [documentsStore.length, intl, onSave, onSubmit, setupPayload, vehicles.length],
  );

  const contextProvider = useMemo(() => {
    return {
      isInternalForm: false,
      hideActionBtnRequest: true,
      hideFinalizeBtn: false,
      mainColor: 'secondary',
      loadingDocuments,
      setLoadingDocuments,
      onCancel,
      onSave: handleSave,
      onSubmit: handleSubmit,
      initialValues,
      validationSchema,
      validateOnSave: true,
      canEdit,
      user: authUser,
      errorsList,
      setErrorsList,
    };
  }, [
    authUser,
    canEdit,
    errorsList,
    handleSave,
    handleSubmit,
    initialValues,
    loadingDocuments,
    onCancel,
    setLoadingDocuments,
    validationSchema,
  ]);

  const renderRequest = () => {
    const internalCdServico = internalNewRequest.cdServico || request.cdServico;
    let Component = SERVICES_PROPERTIES[internalCdServico] ? (
      SERVICES_PROPERTIES[internalCdServico].component
    ) : (
      <></>
    );

    return (
      <>
        {loading && (
          <div className={classes.centerProgress}>
            <CircularProgress size={20} />
          </div>
        )}
        {!loading && (
          <FormServiceContext.Provider value={contextProvider}>
            <Component {...props} />
          </FormServiceContext.Provider>
        )}
      </>
    );
  };

  return renderRequest();
};

export default injectIntl(Vehicles);
